import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fail",
  "use": "icon-fail-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-fail\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M13.41,12,17,15.54,15.54,17,12,13.41,8.46,17,7.05,15.54,10.59,12,7.05,8.46,8.46,7.05,12,10.59l3.54-3.54L17,8.46Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol